import { signalStore, withComputed } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { withLogger } from '@ngrx-traits/signals';
import { UserRightsStore } from '@core/user-rights';

export type AppGateState = 'no-roles' | 'authorized';

export const AppGateStore = signalStore(
  withComputed(() => {
    const userRightsStore = inject(UserRightsStore);
    return {
      accessState: computed<AppGateState>(() =>
        userRightsStore.hasNoRoles() ? 'no-roles' : 'authorized'
      ),
    };
  }),
  withLogger({ name: 'AppGateStore' })
);
